/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import AuthService from "../services/AuthService";
import * as authAction from "../actions/auth";
import ToastService from '../services/ToastService';
import { Link } from "react-router-dom";
export const userData = localStorage.getItem("persist:root")
  ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).userData)
  : "";

const required = (value, name) => {
  if (!name.value) {
    return (
      <div className="isaerror" role="alert">
        Please enter your {name.name}
      </div>
    );
  }
};
class ForgotPwd3 extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    if (userData.token) this.props.history.push({ pathname: "/" });
    this.error = false;

    this.state = {
      key: props.token,
      password: "", type: this.props.type, oldPassword: '',
      authImage: [], confirmPassword: '', pwdValidation: [], setConfirmTouched: false, setPwdTouched: false,
    };

  }
  samePwdCheck = (password, confirmPwd) => {
    if (password === confirmPwd) this.setState({ pwdConfirm: " " });
    else
      this.setState({
        pwdConfirm: (
          <div className="isaerror" role="alert">
            Confirm password is not matched
          </div>
        ),
      });
  };
  isValidpassword = (value, name) => {
    const { pwdValidation } = this.state;
    this.setState({ touchedPwd: name });
    const pwdPattern = new RegExp(/(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[@$!%*#?~(&)+=^_-]).{8,}/);

    if (!pwdPattern.test(value) || value.length < 8) {
      pwdValidation[name] = (
        <div className="isaerror" role="alert">
          Password must be at least 8 characters long, include letters, numbers, & 1 special character.
        </div>
      );
    } else pwdValidation[name] = "";
    // } else { this.error = false; }
  };
  handleForgetPwd = (e) => {
    e.preventDefault();
    const { key, confirmPassword, type, oldPassword } = this.state
    if (type === 'login') {
      AuthService.setNewPwd({ 'old_pass': oldPassword, 'new_pass': confirmPassword })
        .then(result => {
          if (!result) return;
          ToastService.success(result.message);
          localStorage.clear();
          window.open('/login', "_self");

        })
        .catch(err => {
          console.error(err);
        });
    }


    else {
      AuthService.setForgetPwd({ 'key': key, 'new_pass': confirmPassword })
        .then(result => {
          if (!result) return;
          ToastService.success(result.message);

          this.props.history.push({
            pathname: "/login",
          });

        })
        .catch(err => {
          console.error(err);
        });
    }
  };

  bgshapestyle = {
    clipPath: "polygon(0 0, 100% 0, 100% 71%, 0% 100%)",
    background: "#00A88A",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "0",
    padding: "0 0 1rem 0",
  };

  innerform = {
    zIndex: "9",
    position: "inherit",
    padding: "40px 0",
  };

  loginbox = {
    // background: "#FFFFFF",
    // boxShadow: "6px 4px 21px rgba(0, 0, 0, 0.25)",
    // borderRadius: "20px",
    /* From https://css.glass */
    background: "rgb(255 255 255 / 83%)",
    borderRadius: "16px",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10.4px)",
    WebkitBackdropFilter: "blur(10.4px)",
    border: "1px solid rgba(255, 255, 255, 0.28)",
  };

  normalhd = {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "22px",
    lineHeight: "28px",
    color: "rgb(89 89 89)",
    margin: "0",
  };

  colorhd = {
    fontStyle: "normal",
    fontWeight: "800",
    lineHeight: "28px",
    background: "linear-gradient(90deg, #F19755 5.81%, #00A88A 100%)",
    backgroundClip: "text",
    margin: "0",
    textFillColor: "transparent",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  benefitGrid = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr",
    columnGap: "1rem",
    rowGap: "1rem",
    marginTop: "1rem",
    flexGrow: "1",
  };

  gridcell = {
    // border: '1px solid gray',
    // borderRadius: '10px',
    backgroundColor: "white",
    // boxShadow: "rgb(0 133 109) -10px -10px 15px, rgb(0 0 0 / 15%) 10px 10px 15px",
    /* From https://css.glass */
    background: "rgba(255, 255, 255, 0.33)",
    borderRadius: "16px",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(10.4px)",
    WebkitBackdropFilter: "blur(10.4px)",
    border: "1px solid rgba(255, 255, 255, 0.28)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: "8px",
    justifyContent: "center",
    padding: "1rem",
    overflow: "clip",
  };

  render() {
    const { username, password, authImage, confirmPassword, pwdValidation, pwdConfirm, touchedPwd, type, oldPassword } = this.state;
    return (
      <div style={{ position: "relative" }}>
        <div className="bgshape" style={this.bgshapestyle}></div>
        <button
          type="button"
          className="btn-close"
          onClick={() => this.props.dismissModal()}
        ></button>
        <div className="container" style={this.innerform}>
          <form
            className="formRegistration row"
            ref={c => {
              this.form = c;
            }}
            style={{
              minHeight: "40vh",
              zIndex: "9",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="col-sm-5">
              {/* below is the form */}
              <section className="agploginbox" style={this.loginbox}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      columnGap: "1rem",
                      minHeight: "40vh",
                      padding: "1.5rem",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* below is the registration heading logos section*/}
                    <div
                      className="agploginbox-header"
                      style={{
                        display: "flex",
                        width: "100%",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={require("../public/grid-logo-1.png")}
                        alt="Ayush grid logo"
                        style={{
                          flexGrow: "1",
                          width: "166px",
                          height: "63px",
                        }}
                      />
                      <div
                        className="mverline-hide"
                        style={{
                          width: "5px",
                          height: "51px",
                          background: "#F09755",
                          borderRadius: "20px",
                        }}
                      ></div>
                      <div
                        className="agplb-signcmt"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flexGrow: "1",
                        }}
                      >
                        <p style={this.normalhd}>
                          {type === 'login' ? '' : 'Password Recovery'}
                          <br />
                          <span style={this.colorhd}>Ayush Global Portal</span>
                        </p>
                      </div>
                    </div>
                    <p
                      style={{
                        fontStyle: "italic",
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#808080",
                        margin: "1rem 0.5rem",
                      }}
                    >
                      Enter your details below to recover your password
                    </p>
                    {/* below is the main registration fields */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "1rem",
                      }}
                    >
                      {type === 'login' ? <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="password"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Current Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="confirmPassword"
                          minLength="8"
                          disabled={pwdValidation.password}
                          value={oldPassword}
                          onChange={e =>
                            this.setState({ oldPassword: e.target.value })
                          }

                        />
                        {/* {touchedPwd === "confirmPassword" &&
                          (pwdValidation.confirmPassword || pwdConfirm)} */}
                      </div> : ''}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="password"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="password"
                          minLength="8"
                          value={password}
                          onChange={e =>
                            this.setState({ password: e.target.value })
                          }
                          onBlur={e => (
                            this.setState({ setPwdTouched: true }),
                            this.isValidpassword(e.target.value, e.target.name)
                          )}
                        />
                        {touchedPwd === "password" && pwdValidation.password}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "0 0.5rem",
                        }}
                      >
                        <label
                          htmlFor="password"
                          style={{
                            marginBottom: "0.25rem",
                            color: "#9e9e9e",
                            fontSize: "14px",
                          }}
                        >
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          name="confirmPassword"
                          minLength="8"
                          disabled={pwdValidation.password}
                          value={confirmPassword}
                          onChange={e =>
                            this.setState({ confirmPassword: e.target.value })
                          }
                          onBlur={e => (
                            this.setState({ setConfirmTouched: true }),
                            this.samePwdCheck(password, e.target.value),
                            this.isValidpassword(e.target.value, e.target.name)
                          )}
                        />
                        {touchedPwd === "confirmPassword" &&
                          (pwdValidation.confirmPassword || pwdConfirm)}
                      </div>

                      <p style={{ padding: "0 0.5rem", fontSize: "14px" }}>
                        {type === 'login' ? '' : ' On succesful updation of your password, we will mail you  the login credentials on your registered mail id.'}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "0 0.5rem",
                          rowGap: "8px",
                        }}
                      >
                        <button
                          onClick={e => this.handleForgetPwd(e)}
                          disabled={!(password && confirmPassword)}
                          style={{
                            backgroundColor: "#007e67",
                            borderRadius: "14px",
                            border: "none",
                            padding: "1rem",
                            fontWeight: "600",
                            fontSize: "18px",
                            color: "white",
                          }}
                        >
                          Update my password.
                        </button>

                      </div>
                    </div>
                    {/* registration form end */}
                  </div>
                </div>
              </section>
            </div>
            {/*  */}
            {/*  */}
          </form>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return { translation: state.translation };
};
const mapDispatchToProps = dispatch => {
  return {
    userDetail: user => dispatch(authAction.userDetail(user)),
  };
};
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
)(ForgotPwd3);
